import "./Contact.css";
import { FaPhoneAlt, FaEnvelope, FaClock, FaMapMarkerAlt } from "react-icons/fa";
import { useState } from "react";
function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://contact-api-coral.vercel.app/send",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("Failed to send message. Please try again.");
      }
    } catch (error) {
      setStatus("Something went wrong. Please try later.");
    }
  };
  return (
    <div className="contact-background">
      <div className="contact-title">CONTACT US</div>
      <div className="contact-sub-title">
        We'd love to hear from you. Contact us for any inquiries about our services or to discuss your certification needs.
      </div>

      <div className="contact-container">
 
        <div className="contact-info">
          <h3>Contact Information</h3>

          <div className="info-item">
            <FaMapMarkerAlt className="info-icon purple" />
            <div>
              <h4>Office Address</h4>
              <p>Plot No. 75, Kamaraj Nagar, 6th Street, Korattur, Chennai, Tamil Nadu – 600080</p>
            </div>
          </div>

          <div className="info-item">
            <FaPhoneAlt className="info-icon pink" />
            <div>
              <h4>Phone Number</h4>
              <p>+91 9443407953</p>
              <p>+91 8310158267</p>
            </div>
          </div>

          <div className="info-item">
            <FaEnvelope className="info-icon green" />
            <div>
              <h4>Email Address</h4>
              <p>amyflorisindia@gmail.com</p>
              <p>amyflorisindia@outlook.com</p>
            </div>
          </div>

          <div className="info-item">
            <FaClock className="info-icon orange" />
            <div>
              <h4>Working Hours</h4>
              <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p>Saturday: 9:00 AM - 1:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>
        <div className="contact-form">
          <h3>Get In Touch</h3>

          <form onSubmit={handleSubmit}>
            <div>
              <h6>Name</h6>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <h6>Email</h6>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <h6>Phone Number</h6>
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <h6>Message</h6>
              <textarea
                name="message"
                placeholder="Message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit">Send Message</button>

            {status && <p className="form-status">{status}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
